import React from 'react'

import TotalCountChart from 'components/charts/InlineCountChart'
import LineChart from 'components/charts/LineChart'
import useDateRange from 'hooks/useDateRange'
import useQueryConfig, { UseQueryConfigProps } from 'hooks/useQueryConfig'

import useMeetingCount from './useMeetingCount.hook'

interface Props extends UseQueryConfigProps {
  cumulative?: boolean
  title: string
  tooltip?: string
  tooltipFlow: string
}

const MeetingLineChart = ({
  metric,
  cumulative = false,
  title,
  tooltip,
  tooltipFlow,
}: Props) => {
  const { currentSeriesLabel, prevSeriesLabel } = useDateRange()
  const { queryConfig } = useQueryConfig(metric)

  const {
    metric: currentMetric,
    previousMetric,
    isLoading,
  } = useMeetingCount(queryConfig)

  const MeetingsInlineCountChart = () => {
    return (
      <TotalCountChart
        title={'meeting'}
        loading={isLoading}
        data={currentMetric}
      />
    )
  }

  return (
    <LineChart
      cumulative={cumulative}
      queryConfig={queryConfig}
      currentSeries={currentMetric}
      currentSeriesLabel={currentSeriesLabel}
      prevSeries={previousMetric}
      prevSeriesLabel={prevSeriesLabel}
      inlineCountChart={MeetingsInlineCountChart}
      loading={isLoading}
      error={false}
      title={title}
      subtitle={false}
      tooltip={tooltip}
      tooltipFlow={tooltipFlow}
    />
  )
}

export default MeetingLineChart
